
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeLote: null,
    lotes: [],
    isLoadingLote: false,
    totalLote: 0,
    
});






export const useLotesStore = create()(
    devtools(
        storeApi
    )
)
